import React from 'react';
import { DispatchProp } from 'react-redux';
import { useSetResolved } from 'src/core/engine/router';
import { CmsFaqPage } from 'src/components/CmsPage/CmsFaqPage';
import { DefaultMeta } from 'src/components/AppShell/Head';

import '../../scss/_root-component.scss';

import meta from './CmsFaq.json';

type Props = {
    id: number;
} & DispatchProp<any>;

export const CmsFaq: React.FC<Props> = () => {
    useSetResolved();

    return (
        <>
            <DefaultMeta data={meta.helmet} />
            <CmsFaqPage />
        </>
    );
};

export default CmsFaq;
